import styled from "@emotion/styled";
export const StyledImagesGalleryRowComponent = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;
